/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Cancellation_CommitmentInputs */

const en_admin_allocation_form_cancellation_commitment = /** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation & Commitment`)
};

const de_admin_allocation_form_cancellation_commitment = /** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung & Mindestlaufzeit`)
};

const es_admin_allocation_form_cancellation_commitment = /** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación y Compromiso`)
};

const fr_admin_allocation_form_cancellation_commitment = /** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résiliation & Engagement`)
};

const nl_admin_allocation_form_cancellation_commitment = /** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzegging & verbintenis`)
};

/** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */
const it_admin_allocation_form_cancellation_commitment = en_admin_allocation_form_cancellation_commitment;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_cancellation_commitment = en_admin_allocation_form_cancellation_commitment;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */
const pl_admin_allocation_form_cancellation_commitment = en_admin_allocation_form_cancellation_commitment;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */
const hu_admin_allocation_form_cancellation_commitment = en_admin_allocation_form_cancellation_commitment;

/** @type {(inputs: Admin_Allocation_Form_Cancellation_CommitmentInputs) => LocalizedString} */
const ro_admin_allocation_form_cancellation_commitment = en_admin_allocation_form_cancellation_commitment;

/**
* | output |
* | --- |
* | "Cancellation & Commitment" |
*
* @param {Admin_Allocation_Form_Cancellation_CommitmentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_cancellation_commitment = /** @type {((inputs?: Admin_Allocation_Form_Cancellation_CommitmentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Cancellation_CommitmentInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "de") return de_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "es") return es_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "fr") return fr_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "nl") return nl_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "it") return it_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "pl") return pl_admin_allocation_form_cancellation_commitment(inputs)
	if (locale === "hu") return hu_admin_allocation_form_cancellation_commitment(inputs)
	return ro_admin_allocation_form_cancellation_commitment(inputs)
});
export { admin_allocation_form_cancellation_commitment as "admin.allocation_form.cancellation_commitment" }